<template>
    <div class="rb">

        <div ref="Rmain" class="Rmain" :style="{ width: '480px', height: '280px' }"></div>
    </div>
</template>

<script>

export default {
    name: 'template.rightBottom',
    data() {
        return {
            chartDom: "",
            myChart: "",
            option: "",
            TmyChart: "",
            Toption: "",
            titleName4: "",
        }
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        TdrawLine() {
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.Rmain);
            let myDate = ['0.00', '4.00', '8.00', '12.00', '16.00', '20.00'];

            let numA = [4, 5, 6, 5, 7, 8];
            var Toption = {
                title: {

                    subtext: '万元',
                    subtextStyle: {
                        color: "#B0B5BB",

                    },
                    top: '8',
                    left: '18'

                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    // type: 'category',
                    boundaryGap: false,
                    data: myDate,
                    
                    axisLabel: {
                        interval: 0,
                        // padding: [0, 0, 0, 40],
                        margin:12,
                        textStyle: {
                            color: '#bdc2cb' // 这里将 x 轴文本颜色设为灰白色
                        }
                    }
                },

                yAxis: {
                    // type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#bdc2cb' // 这里将 x 轴文本颜色设为灰白色
                        }
                    },
                    nameTextStyle: {
                        padding: [0, 6, 0, 0]

                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: 'dashed',
                            color: "rgba(231,241,251,.2)"
                        }
                    }

                },
                series: [
                    {
                        data: numA,
                        type: 'line',
                        areaStyle: {},
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            color: '#0A72FC',
                            width: 2,

                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: "#0b56bd" // 0% 处的颜色 
                                }, {
                                    offset: 0.6,
                                    color: "#0c2a5c" // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "rgba(0,0,0,.3)" // 100% 处的颜色
                                }], false)
                            }
                        },
                    }
                ]
            };
            Toption && TmyChart.setOption(Toption);
            setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        },
    },
    mounted() {
        this.$nextTick(() => {
            // this.drawLine(); //需要刷新的数据
            this.TdrawLine(); //需要刷新的数据
        });



    },
}
</script>

<style scoped>
.rb {
    width: 480px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    position: relative;

    box-sizing: border-box;
}

.Rmain {
    position: absolute;
    left: -12px;
    top: 0px;
    width: 480px;
    height: 240px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}
</style>